export const defaultPricing = {
  defaultLowestLuggagePrice: 300,
  defaultLuggagePrice: 590,
  defaultCurrency: "USD",
}
